<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-icon>assignment_ind</v-icon>
      <v-menu :nudge-width="100">
        <v-toolbar-title slot="activator">
          <span class="text-xs-right ml-2">Vendor List</span>
        </v-toolbar-title>
      </v-menu>
      <v-spacer></v-spacer>
      <!-- Toolbar Button non-mobile -->
      <v-flex hidden-xs-only class="text-xs-right">
        <v-btn flat class="primary" @click="createVendorDialog = true" @closeDialog="createVendorDialog = true">
          <v-icon left>person_add</v-icon>New Vendor
        </v-btn>
      </v-flex>
      <!-- Toolbar Button mobile -->
      <v-flex hidden-sm-and-up class="text-xs-right">
        <v-btn icon accent class="primary" @click="createVendorDialog = true" @closeDialog="createVendorDialog = true">
          <v-icon>person_add</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar>
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <!-- <v-flex sm8 xs12>
            <v-menu :close-on-content-click="false" :nudge-width="200" v-model="VendorFilters" offset-x>
              <v-btn slot="activator" icon><v-icon color="orange">arrow_drop_down_circle</v-icon></v-btn>
            </v-menu>
          </v-flex> -->
          <v-spacer></v-spacer>
        <!-- Search Box -->
          <v-flex sm4 xs12>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <!-- End: Search Box -->
        <!-- Table Contents -->
      </v-card-title>
      <v-data-table :headers="headers" :loading="loading" :rows-per-page-items="[10,25,50,100,{'text':'All','value':-1}]" :items="vendors" :search="search" :item-key="vendors.id">
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">{{ props.header.text }}</span>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <tr style="cursor: pointer">
          <td @click="selectVendor(props.item.id)">
            <v-layout row>
              <v-icon>assignment_ind</v-icon>
              <v-layout row wrap>
                <v-flex class="title ml-2">{{ props.item.company_name }}</v-flex>
              </v-layout>
            </v-layout>
          </td>
          <td @click="selectVendor(props.item.id)">
            <v-layout row hidden-md-and-down>
              <v-layout row wrap>
                <v-flex class="title">{{ props.item.vendor_type.join(', ') }}</v-flex>
              </v-layout>
            </v-layout>
          </td>
          <td class="justify-center layout px-0">
            <v-icon medium @click="deleteVendor(props.item)">delete</v-icon>
          </td>
          </tr>
        </template>
      </v-data-table>
        <!-- End: Table Contents -->
    </v-card>
  <!-- Create Vendor Dialog -->
    <v-dialog max-width="800px" persistent v-model="createVendorDialog">
      <create-Vendor v-if="createVendorDialog" @closeDialog="createVendorDialog = false"/>
    </v-dialog>
  <!-- End: Create Vendor Dialog -->
  </div>
</template>

<script>
  import CreateVendor from './CreateVendor'
  // import { db } from '../../firebaseInit'

  export default {
    data () {
      return {
        showCard: null,
        createVendorDialog: false,
        search: null,
        headers: [
        { text: 'Vendor', align: 'left', value: 'company_name' },
        { text: 'Vendor Type', value: 'vendor_type' },
        { text: '', value: 'delete' }
        // Hidden Headers Used For Search
        // { text: 'first_name', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'first_name' },
        // { text: 'last_name', class: ['hidden-sm-and-up', 'hidden-xs-only'], value: 'last_name' }
        ]
      }
    },
    async created () {
      this.$store.dispatch('getVendorList')
    },
    computed: {
      vendors () {
        return this.$store.getters.vendorList
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      formatPhoneNumber (value) {
        let s2 = ('' + value).replace(/\D/g, '')
        let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
        return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
      },
      selectVendor (vendorId) {
        this.$router.push('/vendors/' + vendorId)
        this.$emit('closeDialog')
      },
      deleteVendor (item) {
        confirm('Are you sure you want to delete the Vendor ' + item.company_name + '?') && this.$store.dispatch('deleteVendor', item)
      }
    },
    components: {
      CreateVendor
    }
  }
</script>

<style scoped>
  .header {
    float: left;
    margin-bottom: 40px;
  }
  .hideHeader {
    color: red;
  }
  .createButton {
    float: right;
  }
  table.table tbody td {
    cursor: pointer;
    font-size: 20px;
    text-align: left;
    padding-right: 0px;
  }
  .icon {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/vendors/VendorList.vue